var render = function render(){var _vm=this,_c=_vm._self._c;return _c('Slidebar',{attrs:{"large":true},on:{"closeMe":_vm.closeSlidebar}},[_c('h4',[_vm._v(_vm._s(_vm.item.name))]),_c('h5',[_vm._v("Pantanir")]),_c('br'),_c('Timetable'),_c('br'),_c('b-btn',{attrs:{"variant":"primary"},on:{"click":_vm.closeSlidebar}},[_vm._v("Loka")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }